/* ManhArt Gemstones – Filterveredelung fuer Dawn.
   Preis und Gewicht als Doppelregler, Schliffform als Kacheln mit Formsymbolen,
   Farbe als Farbpunkte.

   Wichtig zum Wiederaufbau: Dawn tauscht beim Filtern nur das innerHTML der
   Filterbloecke aus, das Blockelement selbst bleibt bestehen. Eine Merkmarkierung
   am Block wuerde also ueberleben und den Neuaufbau verhindern – die Formkacheln
   und der Gewichtsregler waeren nach dem ersten Filterklick wieder Checkboxen.
   Deshalb erkennen wir den Zustand ausschliesslich am ausgetauschten Inhalt. */
(function () {
  'use strict';

  var P_WEIGHT = 'filter.p.m.custom.gewicht_ct';
  var P_SHAPE = 'filter.p.m.custom.schliffform';
  var P_COLOR = 'filter.p.m.custom.farbe';

  var COLORS = {
    blau: '#2f5fd0', blue: '#2f5fd0',
    hellblau: '#7fb2e5', tuerkis: '#1aa9a0', teal: '#1aa9a0',
    gruen: '#2e8b57', green: '#2e8b57',
    rot: '#c0392b', red: '#c0392b',
    rosa: '#e58fb0', pink: '#e58fb0',
    gelb: '#e6b422', yellow: '#e6b422',
    orange: '#e07b26',
    violett: '#7b52ab', lila: '#7b52ab', purple: '#7b52ab',
    braun: '#8a5a2b', brown: '#8a5a2b',
    grau: '#8a8f94', grey: '#8a8f94', gray: '#8a8f94',
    schwarz: '#1c1c1c', black: '#1c1c1c',
    weiss: '#f4f6f7', white: '#f4f6f7',
    farblos: '#eef2f4', colourless: '#eef2f4', colorless: '#eef2f4',
    mehrfarbig: 'linear-gradient(135deg,#c0392b,#e6b422,#2e8b57,#2f5fd0)',
    bunt: 'linear-gradient(135deg,#c0392b,#e6b422,#2e8b57,#2f5fd0)'
  };

  var SHAPES = {
    rund: '<circle cx="16" cy="16" r="12"/>',
    round: '<circle cx="16" cy="16" r="12"/>',
    oval: '<ellipse cx="16" cy="16" rx="9" ry="12.5"/>',
    rechteck: '<rect x="4.5" y="9" width="23" height="14" rx="1.5"/>',
    rectangle: '<rect x="4.5" y="9" width="23" height="14" rx="1.5"/>',
    baguette: '<rect x="7" y="5" width="18" height="22" rx="1.5"/>',
    quadrat: '<rect x="6" y="6" width="20" height="20" rx="1.5"/>',
    square: '<rect x="6" y="6" width="20" height="20" rx="1.5"/>',
    oktagon: '<path d="M11.5 4h9l7.5 7.5v9L20.5 28h-9L4 20.5v-9z"/>',
    octagon: '<path d="M11.5 4h9l7.5 7.5v9L20.5 28h-9L4 20.5v-9z"/>',
    smaragd: '<path d="M11 5h10l6 6v10l-6 6H11l-6-6V11z"/>',
    emerald: '<path d="M11 5h10l6 6v10l-6 6H11l-6-6V11z"/>',
    trilliant: '<path d="M16 4.5 28 26H4z"/>',
    dreieck: '<path d="M16 4.5 28 26H4z"/>',
    triangle: '<path d="M16 4.5 28 26H4z"/>',
    marquise: '<path d="M16 3.5c5 4.5 8 8.5 8 12.5s-3 8-8 12.5c-5-4.5-8-8.5-8-12.5s3-8 8-12.5z"/>',
    tropfen: '<path d="M16 3.5c5.5 5 9 9 9 13.5a9 9 0 0 1-18 0c0-4.5 3.5-8.5 9-13.5z"/>',
    birne: '<path d="M16 3.5c5.5 5 9 9 9 13.5a9 9 0 0 1-18 0c0-4.5 3.5-8.5 9-13.5z"/>',
    pear: '<path d="M16 3.5c5.5 5 9 9 9 13.5a9 9 0 0 1-18 0c0-4.5 3.5-8.5 9-13.5z"/>',
    herz: '<path d="M16 27S4.5 19.5 4.5 12.2A6.2 6.2 0 0 1 16 8.9a6.2 6.2 0 0 1 11.5 3.3C27.5 19.5 16 27 16 27z"/>',
    kissen: '<path d="M10 5h12a5 5 0 0 1 5 5v12a5 5 0 0 1-5 5H10a5 5 0 0 1-5-5V10a5 5 0 0 1 5-5z"/>',
    cushion: '<path d="M10 5h12a5 5 0 0 1 5 5v12a5 5 0 0 1-5 5H10a5 5 0 0 1-5-5V10a5 5 0 0 1 5-5z"/>',
    fantasie: '<path d="M16 3.2c6.6 3.6 12 7.6 12 13.3 0 6-5.4 9.8-12 11.9C9.4 26.3 4 22.5 4 16.5 4 10.8 9.4 6.8 16 3.2z"/>',
    fancy: '<path d="M16 3.2c6.6 3.6 12 7.6 12 13.3 0 6-5.4 9.8-12 11.9C9.4 26.3 4 22.5 4 16.5 4 10.8 9.4 6.8 16 3.2z"/>'
  };

  var FALLBACK_SHAPE = '<path d="M16 4 28 16 16 28 4 16z"/>';

  function isGuest() {
    return document.body.classList.contains('mf-guest');
  }

  function deumlaut(s) {
    return s.replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss');
  }

  function norm(value) {
    return deumlaut(String(value || '').trim().toLowerCase())
      .replace(/schliff$/, '')
      .replace(/[^a-z0-9]/g, '');
  }

  function deNum(value, digits) {
    return Number(value).toLocaleString('de-DE', {
      minimumFractionDigits: digits,
      maximumFractionDigits: digits
    });
  }

  /* Runde Schrittweite, damit im Regler keine krummen Betraege stehen. */
  function niceStep(max) {
    if (max <= 50) return 1;
    if (max <= 500) return 5;
    if (max <= 5000) return 10;
    if (max <= 50000) return 50;
    return 100;
  }

  /* Wandelt Dawns lokalisierte Preisangabe ("1.800,00") in eine Zahl. */
  function parseLocaleNumber(text) {
    var raw = String(text || '').replace(/[^0-9.,]/g, '');
    if (!raw) return NaN;
    var lastComma = raw.lastIndexOf(',');
    var lastDot = raw.lastIndexOf('.');
    var decimalAt = Math.max(lastComma, lastDot);
    var hasDecimals = decimalAt > -1 && raw.length - decimalAt - 1 <= 2;
    var intPart = hasDecimals ? raw.slice(0, decimalAt) : raw;
    var fracPart = hasDecimals ? raw.slice(decimalAt + 1) : '';
    intPart = intPart.replace(/[.,]/g, '');
    return Number(fracPart ? intPart + '.' + fracPart : intPart);
  }

  function facetFor(paramName, root) {
    var input = (root || document).querySelector('[name="' + paramName + '"]');
    return input ? input.closest('.js-filter, .mobile-facets__details') : null;
  }

  function notifyDawn(el) {
    el.dispatchEvent(new Event('input', { bubbles: true }));
    el.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /* Baut einen Doppelregler und meldet Aenderungen erst beim Loslassen. */
  function buildRange(opts) {
    var wrap = document.createElement('div');
    wrap.className = 'mf-range';

    var values = document.createElement('div');
    values.className = 'mf-range__values';
    wrap.appendChild(values);

    var track = document.createElement('div');
    track.className = 'mf-range__track';
    var rail = document.createElement('div');
    rail.className = 'mf-range__rail';
    var fill = document.createElement('div');
    fill.className = 'mf-range__fill';
    track.appendChild(rail);
    track.appendChild(fill);

    var lo = document.createElement('input');
    var hi = document.createElement('input');
    [lo, hi].forEach(function (input, index) {
      input.type = 'range';
      input.min = opts.min;
      input.max = opts.max;
      input.step = opts.step;
      input.setAttribute('aria-label', index === 0 ? opts.labelFrom : opts.labelTo);
      track.appendChild(input);
    });
    lo.value = opts.valueFrom;
    hi.value = opts.valueTo;
    wrap.appendChild(track);

    function span() {
      return Math.max(opts.max - opts.min, 0.0001);
    }

    function paint() {
      var a = Number(lo.value);
      var b = Number(hi.value);
      var left = ((Math.min(a, b) - opts.min) / span()) * 100;
      var right = ((Math.max(a, b) - opts.min) / span()) * 100;
      fill.style.left = left + '%';
      fill.style.width = Math.max(right - left, 0) + '%';
      values.textContent = opts.format(Math.min(a, b), Math.max(a, b));
    }

    function clamp(isLow, other) {
      var a = Number(lo.value);
      var b = Number(hi.value);
      if (isLow && a > b) other.value = a;
      if (!isLow && b < a) other.value = b;
    }

    function commit() {
      opts.onCommit(
        Math.min(Number(lo.value), Number(hi.value)),
        Math.max(Number(lo.value), Number(hi.value))
      );
    }

    lo.addEventListener('input', function () { clamp(true, hi); paint(); });
    hi.addEventListener('input', function () { clamp(false, lo); paint(); });
    lo.addEventListener('change', commit);
    hi.addEventListener('change', commit);

    paint();
    return wrap;
  }

  /* ---- Preis: Doppelregler. Fuer Gaeste liefert Liquid den Block gar nicht erst
     aus; die Entfernung hier ist nur die zweite Sicherung. ---- */
  function enhancePrice(root) {
    var priceRange = root.querySelector('price-range');
    if (!priceRange) return;

    if (isGuest()) {
      var block = priceRange.closest('.js-filter, .mobile-facets__details');
      (block || priceRange).remove();
      return;
    }

    if (priceRange.classList.contains('mf-hidden')) return;
    var from = priceRange.querySelector('[name="filter.v.price.gte"]');
    var to = priceRange.querySelector('[name="filter.v.price.lte"]');
    if (!from || !to) return;

    var max = parseLocaleNumber(to.getAttribute('data-max') || from.getAttribute('data-max'));
    if (!isFinite(max) || max <= 0) return;
    var step = niceStep(max);
    max = Math.ceil(max / step) * step;

    var currentFrom = parseLocaleNumber(from.value);
    var currentTo = parseLocaleNumber(to.value);
    var money = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 });

    var slider = buildRange({
      min: 0,
      max: max,
      step: step,
      valueFrom: isFinite(currentFrom) ? currentFrom : 0,
      valueTo: isFinite(currentTo) ? currentTo : max,
      labelFrom: 'Preis von',
      labelTo: 'Preis bis',
      format: function (a, b) { return money.format(a) + ' – ' + money.format(b); },
      onCommit: function (a, b) {
        from.value = a > 0 ? String(a) : '';
        to.value = b < max ? String(b) : '';
        notifyDawn(to);
      }
    });

    priceRange.parentNode.insertBefore(slider, priceRange);
    priceRange.classList.add('mf-hidden');
  }

  /* ---- Gewicht: Doppelregler, der im Hintergrund Listenwerte ankreuzt ---- */
  function enhanceWeight(root) {
    var facet = facetFor(P_WEIGHT, root);
    if (!facet || facet.querySelector('.mf-range')) return;
    var boxes = Array.prototype.slice.call(facet.querySelectorAll('input[type="checkbox"]'));
    if (boxes.length < 2) return;

    var numeric = boxes
      .map(function (box) { return { box: box, value: parseLocaleNumber(box.value) }; })
      .filter(function (item) { return isFinite(item.value); });
    if (numeric.length < 2) return;

    var all = numeric.map(function (item) { return item.value; });
    var min = Math.min.apply(null, all);
    var max = Math.max.apply(null, all);
    if (min === max) return;

    var checked = numeric
      .filter(function (item) { return item.box.checked; })
      .map(function (item) { return item.value; });
    var list = facet.querySelector('ul');

    var slider = buildRange({
      min: min,
      max: max,
      step: 0.01,
      valueFrom: checked.length ? Math.min.apply(null, checked) : min,
      valueTo: checked.length ? Math.max.apply(null, checked) : max,
      labelFrom: 'Gewicht von',
      labelTo: 'Gewicht bis',
      format: function (a, b) { return deNum(a, 2) + ' – ' + deNum(b, 2) + ' ct'; },
      onCommit: function (a, b) {
        var whole = a <= min + 0.0001 && b >= max - 0.0001;
        var last = null;
        numeric.forEach(function (item) {
          var inside = item.value >= a - 0.0001 && item.value <= b + 0.0001;
          var next = whole ? false : inside;
          if (item.box.checked !== next) {
            item.box.checked = next;
            last = item.box;
          }
        });
        if (last) notifyDawn(last);
      }
    });

    if (list) {
      list.parentNode.insertBefore(slider, list);
      list.classList.add('mf-hidden');
    } else {
      facet.appendChild(slider);
    }
  }

  /* Zerlegt Dawns Label in reinen Wert und Anzahl. */
  function splitLabel(label) {
    var text = (label.textContent || '').replace(/\s+/g, ' ').trim();
    var match = text.match(/^(.*?)\s*\((\d+)\)/);
    if (match) return { name: match[1].trim(), count: match[2] };
    return { name: text, count: null };
  }

  /* ---- Schliffform: Kacheln mit Formsymbol ---- */
  function enhanceShape(root) {
    var facet = facetFor(P_SHAPE, root);
    if (!facet) return;
    var list = facet.querySelector('ul');
    if (!list || list.classList.contains('mf-tiles')) return;

    Array.prototype.forEach.call(list.querySelectorAll('li'), function (item) {
      var box = item.querySelector('input[type="checkbox"]');
      var label = item.querySelector('label');
      if (!box || !label) return;
      var info = splitLabel(label);
      var art = SHAPES[norm(box.value)] || FALLBACK_SHAPE;

      label.className = 'mf-tile' + (box.checked ? ' is-checked' : '') + (info.count === '0' ? ' is-empty' : '');
      label.innerHTML = '';
      label.appendChild(box);
      var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('viewBox', '0 0 32 32');
      svg.setAttribute('aria-hidden', 'true');
      svg.innerHTML = art;
      label.appendChild(svg);
      var name = document.createElement('span');
      name.className = 'mf-tile__label';
      name.textContent = info.name;
      label.appendChild(name);
      if (info.count !== null) {
        var count = document.createElement('span');
        count.className = 'mf-tile__count';
        count.textContent = info.count;
        label.appendChild(count);
      }
      box.addEventListener('change', function () {
        label.classList.toggle('is-checked', box.checked);
      });
    });

    list.classList.add('mf-tiles');
  }

  /* ---- Farbe: Farbpunkte ---- */
  function enhanceColor(root) {
    var facet = facetFor(P_COLOR, root);
    if (!facet) return;
    var list = facet.querySelector('ul');
    if (!list || list.classList.contains('mf-swatches')) return;

    Array.prototype.forEach.call(list.querySelectorAll('li'), function (item) {
      var box = item.querySelector('input[type="checkbox"]');
      var label = item.querySelector('label');
      if (!box || !label) return;
      var info = splitLabel(label);
      var paint = COLORS[norm(box.value)] || '#b9c0c5';

      label.className = 'mf-swatch' + (box.checked ? ' is-checked' : '');
      label.innerHTML = '';
      label.appendChild(box);
      var dot = document.createElement('span');
      dot.className = 'mf-swatch__dot';
      dot.style.background = paint;
      label.appendChild(dot);
      var name = document.createElement('span');
      name.textContent = info.name;
      label.appendChild(name);
      if (info.count !== null) {
        var count = document.createElement('span');
        count.className = 'mf-swatch__count';
        count.textContent = '(' + info.count + ')';
        label.appendChild(count);
      }
      box.addEventListener('change', function () {
        label.classList.toggle('is-checked', box.checked);
      });
    });

    list.classList.add('mf-swatches');
  }

  /* Zweite Sicherung: Gaeste sollen auch ueber manuell gesetzte URL-Parameter
     keine Betraege in der Leiste der aktiven Filter sehen. */
  function stripPriceChips() {
    if (!isGuest()) return;
    Array.prototype.forEach.call(document.querySelectorAll('.active-facets__button'), function (chip) {
      var href = chip.getAttribute('href') || '';
      if (href.indexOf('filter.v.price') > -1 || /€/.test(chip.textContent || '')) {
        var holder = chip.closest('facet-remove') || chip;
        holder.remove();
      }
    });
  }

  function enhanceAll() {
    Array.prototype.forEach.call(document.querySelectorAll('.facets, .mobile-facets'), function (root) {
      try {
        enhancePrice(root);
        enhanceWeight(root);
        enhanceShape(root);
        enhanceColor(root);
      } catch (error) {
        if (window.console) console.warn('ManhArt Filter:', error);
      }
    });
    try {
      stripPriceChips();
    } catch (error) {
      if (window.console) console.warn('ManhArt Filter:', error);
    }
  }

  var pending = null;
  function scheduleEnhance() {
    if (pending) clearTimeout(pending);
    pending = setTimeout(enhanceAll, 60);
  }

  function start() {
    enhanceAll();
    /* Dawn ersetzt beim Filtern den Inhalt der Bloecke – danach neu aufbauen. */
    var host = document.getElementById('main-collection-filters')
      || document.getElementById('ProductGridContainer')
      || document.body;
    new MutationObserver(scheduleEnhance).observe(host, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
